import { render, staticRenderFns } from "./policy_list.vue?vue&type=template&id=2dd0943a&scoped=true"
import script from "./policy_list.vue?vue&type=script&lang=js"
export * from "./policy_list.vue?vue&type=script&lang=js"
import style0 from "./policy_list.vue?vue&type=style&index=0&id=2dd0943a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0943a",
  null
  
)

export default component.exports